/**
 * src/api/billing.js
 * Funciones para billing Flow.cl.
 *
 * Flujo:
 * 1. crearCheckout(tier) → {url, customer_id} → redirigir a url (Flow registra tarjeta)
 * 2. Flow redirige a /billing/flow-callback?token=...&tier=...&usuario_id=...
 * 3. Backend verifica + suscribe → redirige a /onboarding
 */
import api from './client'

export const crearCheckout = (tier) =>
  api.post('/billing/checkout', { tier }).then(r => r.data)

export const abrirPortal = () =>
  api.get('/billing/portal').then(r => r.data)

export const getSuscripcion = () =>
  api.get('/billing/suscripcion').then(r => r.data)

export const completarOnboarding = (data) =>
  api.post('/billing/onboarding', data).then(r => r.data)

export const registerUser = (data) =>
  api.post('/auth/register', data).then(r => r.data)

export const loginUser = (data) =>
  api.post('/auth/login', data).then(r => r.data)

export const getMe = () =>
  api.get('/auth/me').then(r => r.data)
